import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { Link } from "react-router-dom";
import Aside from "../../components/Aside/Aside";
import { Profile } from "../../types";

interface history {
  id: number,
  number: string,
  date: number,
  account_id: number,
  status: number,
}

const AccountsHistory: React.FC = () => {
  const [profile, setProfile] = useState<Profile>()
  const [history, setHistory] = useState<history[]>()
  // const [isLoaded, setIsLoaded] = useState(false);
  const [isLoaded] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState("");
  const [isBlocked, setIsBlocked] = useState(true)
  const [isWarning, setIsWarning] = useState("");

  useEffect(() => {
    axios.get("v1/profile/info").then(res => setProfile(res.data));
  }, [])

  const activeSheetsList = async () => {
    try {
      setIsBlocked(false)
      await axios.post("/v1/profile/bill/history", {
        account_id: profile?.basicAccount
      }).then(res => {
        setHistory(res.data)
        if (res.data === null) {
          setIsOpen(false);
          setErrors("Список счетов пуст")
        }
        if (res.data !== null) {
          setIsOpen(true);
        }
      });
    } catch (e) {
      console.log(e)
    }
  }

  // const getAccountPDF = async (nameSheet: string) => {
  //   try {
  //     axios({
  //       url: "v1/profile/bill/download",
  //       // data: { name: `${NumNumber1c}` },
  //       data: { name: nameSheet },
  //       method: "POST",
  //       responseType: "blob",
  //     }).then((response) => {
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", `счет_на_опату.pdf`);
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const openAccountPDF = async (nameSheet: string) => {
    try {
      setIsOpen(false)
      setIsWarning("Ожидайте открытия счета.");
      axios({
        url: "v1/profile/bill/download",
        // data: { name: `${NumNumber1c}` },
        data: { name: nameSheet },
        method: "POST",
        responseType: "arraybuffer",
      }).then((response) => {
        var file = new Blob([response.data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        setIsWarning("");
        setIsOpen(true);
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside isJurical={1} />
      <div style={{ width: "100%" }}>
        <main data-v-dde546dc="" className="el-main">
          <div
            data-v-3563ec52=""
            data-v-dde546dc=""
            className="reports-payments"
          >
            <h1 data-v-3563ec52="">Выставленные счета на оплату</h1>
            <h2 style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "red" }}>{isWarning}</h2>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p style={{ fontSize: "18px" }}>Список счетов</p>
              {isBlocked ?
                <button type="submit" className="el-button el-button--success el-button--small" style={{ fontSize: "14px" }} onClick={activeSheetsList}>Выгрузить</button>
                : null}
            </div>
            {isLoaded ? (
              <div data-v-dde546dc="" className="el-main">
                <div
                  data-v-dde546dc=""
                  className="dashboard justify-center align-center flex"
                >
                  <TailSpin
                    color="#d6f1dc"
                    height={100}
                    width={100}
                  />
                </div>
              </div>
            ) : null}
            {isOpen ? (
              <div data-v-3563ec52="" className="loading-container">
                <div data-v-3563ec52="" className="mt-1">
                  <div
                    data-v-3563ec52=""
                    className="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"
                  >
                    <div className="hidden-columns">
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                    </div>
                    <div className="el-table__header-wrapper">
                      <table
                        cellSpacing="0"
                        cellPadding="0"
                        className="el-table__header"
                      //style={{ width: "100%" }}
                      >
                        <colgroup>
                          <col className="el-table_7_column_23" width="345" />
                          <col className="el-table_7_column_24" width="190" />
                          {/* <col className="el-table_7_column_25" width="257" /> */}
                          <col className="el-table_7_column_26" width="325" />
                          <col className="el-table_7_column_27" width="171" />
                          <col className="gutter" width="0" />
                        </colgroup>
                        <thead className="has-gutter">
                          <tr className="">
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_23 ascending    is-leaf is-sortable"
                            >
                              <div className="cell">Дата</div>
                            </th>
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_24     is-leaf is-sortable"
                            >
                              <div className="cell">Номер счета</div>
                            </th>
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_26     is-leaf"
                            >
                              <div className="cell"></div>
                            </th>
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_27  is-right   is-leaf is-sortable"
                            >
                              <div className="cell">Статус</div>
                            </th>
                            <th
                              className="gutter"
                              style={{ width: 0, display: "none" }}
                            ></th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div className="el-table__body-wrapper is-scrolling-none">
                      <table
                        cellSpacing="0"
                        cellPadding="0"
                        className="el-table__body"
                        style={{ width: 1030 }}
                      >
                        <colgroup>
                          <col className="el-table_7_column_23" width="300" />
                          <col className="el-table_7_column_24" width="171" />
                          <col className="el-table_7_column_26" width="257" />
                          <col className="el-table_7_column_27" width="171" />
                        </colgroup>
                        <tbody>
                          <>
                            {history?.map((element) =>

                              <tr
                                className="el-table__row"
                                style={{ background: "#d6f1dc", color: "black" }}
                              >
                                <td
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_23  "
                                >
                                  <div className="cell">{moment
                                    .unix(element.date)
                                    .format("D MMMM H:mm:ss")}</div>
                                </td>
                                <td
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_24  "
                                >
                                  <div className="cell">
                                    <Link to="" style={{ cursor: "pointer" }} onClick={() => openAccountPDF(element.number)} >{element.number}</Link>
                                  </div>
                                </td>

                                <td
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_26  "
                                >
                                  <div className="cell">

                                  </div>
                                </td>
                                <td
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_27 is-right "
                                >
                                  <div className="cell">
                                    {element.status === 1 ? "оплачен" : "не оплачен"}
                                  </div>
                                </td>
                              </tr>
                            )}


                          </>
                        </tbody>
                      </table>
                    </div>
                    {/* end report div */}

                    <div
                      className="el-table__column-resize-proxy"
                      style={{ display: "none" }}
                    ></div>
                  </div>
                </div>
                <div className="el-loading-mask" style={{ display: "none" }}>
                  <div className="el-loading-spinner">
                    <svg viewBox="25 25 50 50" className="circular">
                      <circle
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        className="path"
                      ></circle>
                    </svg>
                  </div>
                </div>
              </div>
            ) : null}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
              <h1 style={{ color: "red" }}>{errors}</h1>
            </div>
          </div>
        </main>
      </div>
    </div>
  );

}

export default AccountsHistory;